// src/components/AppShell.jsx  (Phase 2)
import React, { useState } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { useApp } from '../context/AppContext'
import { ToastContainer, Modal } from './UI'
import UserManager from './UserManager'

export default function AppShell() {
  const { currentUser, currentProfile, logout, dataLoading } = useApp()
  const [showUsers, setShowUsers] = useState(false)

  if (!currentUser) return null

  const displayName = currentProfile?.name || currentUser.email?.split('@')[0] || 'User'
  const avatarInitials = currentProfile?.initials ||
    displayName.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
  const avatarColor = currentProfile?.color || '#1c3a5e'
  const isAdmin = currentProfile?.role === 'admin'

  return (
    <div className="app-shell">
      <header className="topbar" role="banner">
        <NavLink to="/" className="topbar-brand" aria-label="TecFin home">
          <div className="brand-icon">
            <i className="ti ti-wallet" aria-hidden="true" />
          </div>
          TecFin
        </NavLink>

        <nav aria-label="Main navigation" style={{ display: 'flex' }}>
          <NavLink to="/transactions" className={({ isActive }) => `nav-tab${isActive ? ' active' : ''}`}>
            <i className="ti ti-plus-minus" aria-hidden="true" /><span>Transactions</span>
          </NavLink>
          <NavLink to="/ledger"       className={({ isActive }) => `nav-tab${isActive ? ' active' : ''}`}>
            <i className="ti ti-book-2" aria-hidden="true" /><span>Ledger</span>
          </NavLink>
          <NavLink to="/accounts"     className={({ isActive }) => `nav-tab${isActive ? ' active' : ''}`}>
            <i className="ti ti-credit-card" aria-hidden="true" /><span>Accounts</span>
          </NavLink>
          <NavLink to="/reports"      className={({ isActive }) => `nav-tab${isActive ? ' active' : ''}`}>
            <i className="ti ti-chart-pie" aria-hidden="true" /><span>Reports</span>
          </NavLink>
        </nav>

        <div className="topbar-end">
          {dataLoading && (
            <i className="ti ti-loader-2" style={{ color: 'var(--brand-400)', fontSize: 16, animation: 'spin 1s linear infinite' }} aria-hidden="true" />
          )}
          <span className="topbar-uname">{displayName}</span>
          <div className="user-avatar" style={{ background: avatarColor }} title={displayName}>
            {avatarInitials}
          </div>
          {isAdmin && (
            <button className="topbar-btn" onClick={() => setShowUsers(true)}>
              <i className="ti ti-users" aria-hidden="true" /><span>Users</span>
            </button>
          )}
          <button className="topbar-btn" onClick={logout} aria-label="Logout">
            <i className="ti ti-logout" aria-hidden="true" /><span>Logout</span>
          </button>
        </div>
      </header>

      <main className="page-content" id="main-content" role="main">
        <Outlet />
      </main>

      {isAdmin && <UserManager open={showUsers} onClose={() => setShowUsers(false)} />}

      <ToastContainer />
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}
